import React from 'react';

import {
    Wrapper,
    Heading,
    GreyText,
    Detail,
    SubHeading,
    VideoCaption
} from './GraduateStoriesInner.styled';

export interface Props {
    heading: string;
    videoCaption?: string;
    studentDetails: {
        jobTitle?: string;
        employer?: string;
        courseStudied?: string;
    };
}

const GraduateStoriesInner: React.FC<Props> = props => {
    const { heading, videoCaption, studentDetails } = props;

    return (
        <Wrapper>
            <Heading>{heading}</Heading>
            {videoCaption && <VideoCaption> {videoCaption}</VideoCaption>}
            {studentDetails.jobTitle && (
                <SubHeading>
                    <GreyText>Job title:</GreyText>
                    <Detail>{studentDetails.jobTitle}</Detail>
                </SubHeading>
            )}
            {studentDetails.employer && (
                <SubHeading>
                    <GreyText>Employer:</GreyText>
                    <Detail>{studentDetails.employer}</Detail>
                </SubHeading>
            )}
            {studentDetails.courseStudied && (
                <SubHeading>
                    <GreyText>Studied:</GreyText>
                    <Detail>{studentDetails.courseStudied}</Detail>
                </SubHeading>
            )}
        </Wrapper>
    );
};

export default GraduateStoriesInner;
